import { toast } from 'react-toastify';
import call from '../../../core/services/http';
import departmentConstants from './departmentConstants';
import {
  GET_DEPARTMENTS_REQUEST,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_ERROR,
  GET_AUDIT_DEPARTMENTS_REQUEST,
  GET_AUDIT_DEPARTMENTS_SUCCESS,
  GET_AUDIT_DEPARTMENTS_ERROR,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_ERROR,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_ERROR,
  RESET_DEPARTMENT_STATE,
} from './departmentActionTypes';

const toastrSuccess = (msg) => toast.success(msg);
const toastrError = (msg) => toast.error(msg);

export const getDepartments = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GET_DEPARTMENTS_REQUEST, isLoading: true });
    const response = await call('get', departmentConstants.GET_DEPARTMENTS(payload));
    if (response.data.status) {
      dispatch({
        type: GET_DEPARTMENTS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({ type: GET_DEPARTMENTS_ERROR, isLoading: false, message: response.data.message });
    }
  } catch (error) {
    const msg =
      error.response?.data?.message || 'Sorry, something went wrong';
    dispatch({ type: GET_DEPARTMENTS_ERROR, isLoading: false, message: msg });
    toastrError(msg);
  }
};

export const createDepartment = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DEPARTMENT_REQUEST, isLoading: true, isSuccess: false });
    const response = await call('post', departmentConstants.CREATE_DEPARTMENT, payload);
    if (response.data.status) {
      dispatch({ type: CREATE_DEPARTMENT_SUCCESS, isLoading: false, isSuccess: true });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({ type: CREATE_DEPARTMENT_ERROR, isLoading: false, isSuccess: false, message: response.data.message });
    }
  } catch (error) {
    toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    dispatch({ type: CREATE_DEPARTMENT_ERROR, isLoading: false, isSuccess: false });
  }
};

export const updateDepartment =
  ({ id, payload }) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPDATE_DEPARTMENT_REQUEST, isLoading: true, isSuccess: false });
      const response = await call('patch', departmentConstants.UPDATE_DEPARTMENT(id), payload);
      if (response.data.status) {
        dispatch({ type: UPDATE_DEPARTMENT_SUCCESS, isLoading: false, isSuccess: true });
        toastrSuccess(response.data.message);
      } else {
        toastrError(response.data.message);
        dispatch({ type: UPDATE_DEPARTMENT_ERROR, isLoading: false, isSuccess: false, message: response.data.message });
      }
    } catch (error) {
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
      dispatch({ type: UPDATE_DEPARTMENT_ERROR, isLoading: false, isSuccess: false });
    }
  };

export const getAuditDepartments = () => async (dispatch) => {
  try {
    dispatch({ type: GET_AUDIT_DEPARTMENTS_REQUEST, isLoading: true });
    const response = await call('get', departmentConstants.GET_AUDIT_DEPARTMENTS);
    if (response.data.status) {
      dispatch({ type: GET_AUDIT_DEPARTMENTS_SUCCESS, isLoading: false, payload: response.data });
    } else {
      dispatch({ type: GET_AUDIT_DEPARTMENTS_ERROR, isLoading: false, message: response.data.message });
    }
  } catch (error) {
    dispatch({ type: GET_AUDIT_DEPARTMENTS_ERROR, isLoading: false });
  }
};

export const resetDepartmentState = () => (dispatch) => {
  dispatch({ type: RESET_DEPARTMENT_STATE });
};
